import { render, staticRenderFns } from "./dataReviewMarking.vue?vue&type=template&id=70e04a4f&scoped=true&"
import script from "./dataReviewMarking.vue?vue&type=script&lang=js&"
export * from "./dataReviewMarking.vue?vue&type=script&lang=js&"
import style0 from "./dataReviewMarking.vue?vue&type=style&index=0&id=70e04a4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e04a4f",
  null
  
)

export default component.exports